import { Obra } from "../entities/obra";

export class ObraDTO {
  public nombreEstado: string;
  public nombreObra: string;
  public nombreTramoLicitacion: string;
  public nombreTipoObra?: string;
  public nombreTipoPrioridad?: string;
  public keyCatDireccionAdjunta: string;
  public direccionAdjunta?: string;
  public obra: Obra;
}
